import { render, staticRenderFns } from "./WideNavLoggedOut.vue?vue&type=template&id=4773a98b&scoped=true&"
import script from "./WideNavLoggedOut.vue?vue&type=script&lang=js&"
export * from "./WideNavLoggedOut.vue?vue&type=script&lang=js&"
import style0 from "./WideNavLoggedOut.vue?vue&type=style&index=0&id=4773a98b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4773a98b",
  null
  
)

export default component.exports